export const REQUEST_PASSWORD_RESET_FLOW_ID = 'request-password-reset';

export enum RequestPasswordResetScreenNames {
  REQUEST = 'Request password reset',
  SENT = 'Password reset email sent',
  TOO_SOON = 'Password reset requested too soon',
  ERROR = 'Password reset request failed',
  TECHNICAL_ERROR = 'Password reset request errored',
}

export const REQUEST_PASSWORD_RESET_INTERACTION_IDS = {
  SUBMIT: 'requestPasswordResetSubmit',
  BACK_TO_LOGIN: 'requestPasswordResetBackToLogin',
  RETRY_TOO_SOON: 'requestPasswordResetRetryFromTooSoon',
  RETRY: 'requestPasswordResetRetry',
  RETRY_AFTER_ERROR: 'requestPasswordResetRetryAfterError',
} as const;
